import { userAssistantService } from '@user/services/userAssistantService';
import { userService } from '@user/services/userService';
import { useEffect } from 'react';
import { runInAction } from 'mobx';

import type { OptionType } from '@components/Select';
import { store } from '@store';

interface Data {
    getDoctorOptions(): OptionType[];
}

export function useAssistantDoctors(withSpecialty?: boolean): Data {
    const { authUser, userList } = store;

    useEffect(() => {
        runInAction(async () => {
            await Promise.all([userService.load(), userAssistantService.loadUserPracticeDoctors(authUser.id)]);
        }).catch(console.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function getDoctorOptions(): OptionType[] {
        const practiceDoctorIds = userList.get(authUser.id)?.practiceDoctorIds ?? [];
        const options = userService.makeOptionTypes({ onlyDoctors: true, withFullName: true, withSpecialty });

        return options.sort(option => (practiceDoctorIds.includes(option.value) ? 1 : 0));
    }

    return {
        getDoctorOptions,
    };
}
